import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

// A Clever sync can be started from more than one surface (the Home card, the sidebar "Import From
// Clever" modal, the legacy classes page), and each surface keeps its own reducer. This module-level
// flag is the single place that records "a client-initiated sync is running", so the persisted Home
// Clever card can reflect an in-progress state even when the sync began on another surface — the
// card's own reducer only knows about its own trigger plus a mount-time seed.
type State = {
  /** The id of the client-initiated sync currently running, or null when none is running. */
  runningSyncId: string | null;
};

type Actions = {
  setRunningSyncId: (runningSyncId: State['runningSyncId']) => void;
};

const initialState: State = {
  runningSyncId: null
};

export const useCleverSyncStore = create<State & Actions>()(
  devtools(
    immer((set) => ({
      ...initialState,
      setRunningSyncId: (runningSyncId) => {
        set((state) => {
          state.runningSyncId = runningSyncId;
        });
      }
    }))
  )
);
